$(document).ready(function () {
    $('.cmn-custom-select2').each(function (i, ele) {
        $(ele).select2({
            width: '100%',
            minimumResultsForSearch: -1,
            dropdownParent: $(ele).closest('.cmn-select2-wrapper'),
            dropdownAutoWidth: 'true',
            placeholder: function () {
                $(this).data('placeholder');
            }
        });
    });

    $("#addEnterprice").validate({
        rules: {
            name: {
                required: true,
            },
            email: {
                required: true,
                email: true,
                validate_email: true,
            },
            phone_number: {
                required: true,
                validate_phone: true
            },
            subscription_id: {
                required: true,
            },
            no_of_outlets: {
                required: true,
            },
            brand_name: {
                required: true,
                maxlength: 50
            },
            gst_number: {
                required: true,
                maxlength: 15
            }
        },
        messages: {
            name: {
                required: "Please enter the Name"
            },
            email: {
                required: "Please enter the Email",
                email: "Please enter a valid Email"
            },
            phone_number: {
                required: "Please enter the Phone Number",
            },
            subscription_id: {
                required: "Please select the Requested Plan",
            },
            no_of_outlets: {
                required: "Please enter the No Of Outlets"
            },
            brand_name: {
                required: "Please enter the Brand Name"
            },
            gst_number: {
                required: "Please enter the GST Number",
                maxlength: "Please enter less than 15 character"
            },
        },
        ignore: '',
        errorElement: 'div',
        errorClass: 'validate-message',
        errorPlacement: function (error, element) {
            errorMsgPlacement(error, element);
        },
        invalidHandler: function (event, validator) {
            invalidHandlerSubmit();
        },
        highlight: function (element, errorClass, validClass) {
            $(element).addClass(errorClass).removeClass(validClass);
            $(element).closest('.form-group').addClass('invalid');
        },
        unhighlight: function (element, errorClass, validClass) {
            $(element).removeClass(errorClass).addClass(validClass);
            $(element).closest('.form-group').removeClass('invalid');
        },
        submitHandler: function (form) {
            var _this = $(this);
            $('.js-error').html('');
            $.ajax({
                url: appConfig.api_url + 'subscription/store_enterprise',
                type: 'POST',
                dataType: 'json',
                data: $(form).serialize(),
                beforeSend: function () {
                    showLoader();
                },
                success: function (data) {
                    successToaster(data.meta.message);
                    setTimeout(function () {
                        hideLoader();
                        window.location.href = appConfig.url;
                    }, 2000);
                },
                error: function (xhr) {
                    hideLoader();
                    showErrorAlertFromException(xhr, form);
                }
            });
            return false;
        }
    });

    $('body').on('change', '#subscription_data', function () {
        changeData();
    });
    changeData();
});
function changeData() {
    if ($('#subscription_data').val() != '') {
        var title = $('#subscription_data option:selected').data('title');
        var duration = $('#subscription_data option:selected').data('duration');
        var interval = $('#subscription_data option:selected').data('duration');
        var description = $('#subscription_data option:selected').data('description');
        var price = $('#subscription_data option:selected').data('price');
        $('.description').html('<strong>' + description + '</strong>');
        $('#duration').html('<strong>' + duration.charAt(0).toUpperCase() + duration.slice(1) + "ly Plan" + '</strong>');
        $('#title').html('<strong>' + title + '</strong>');
        $('#price').html('<strong>' + '₹' + price + '</strong>');
        $('#interval').html('<strong>' + '/' + interval + '</strong>');
    }
}